import { Button } from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import { AddOrEditAddressButton } from '../EditAddressButton'
import { AddressErrorsStatus } from '../../popover/hooks/useFulfillmentHelper'
import {
  FormButtonOnEmptyShippingAddressProps,
  useFormButtonOnEmptyShippingAddressModel,
} from './useFormButtonOnEmptyShippingAddressModel'

export const FormButtonOnEmptyShippingAddress: React.FC<FormButtonOnEmptyShippingAddressProps> = props => {
  const model = useFormButtonOnEmptyShippingAddressModel(props)

  return (
    <div className="uc-base">
      <div className="flex flex-row flex-nowrap justify-end gap-3">
        <AddOrEditAddressButton
          variant={
            model.hasIncorrectShippingOrBillingAddress ? 'go' : 'supplementary'
          }
          type={model.buttonType}
          hasError={model.hasError}
          text={model.addOrUpdateAddressText}
          onOpenModal={model.openAddressModal}
        />
        {model.status === AddressErrorsStatus.EMPTYSHIPPING_CORRECTBILLING && (
          <Button
            appearance="primary"
            customDataAttributes={{
              container: {
                'data-track': model.useBillingAddressForShippingDataTrack,
              },
            }}
            loading={props.loading}
            onClick={model.useBillingAddressForShipping}
            size="medium"
          >
            {model.useBillingAddressForShippingText}
          </Button>
        )}
        {model.status === AddressErrorsStatus.EMPTYSHIPPING_INCORRECTBILLING &&
          (!model.isClickedToOpenModal ? (
            <Button
              appearance="primary"
              customDataAttributes={{
                container: {
                  'data-track': model.updateBillingAddressDataTrack,
                },
              }}
              loading={props.loading}
              onClick={model.startUpdatingBillingAddress}
              size="medium"
            >
              {model.updateBillingAddressText}
            </Button>
          ) : (
            <AddOrEditAddressButton
              type="edit"
              hasError={model.hasError}
              onClick={model.copyBillingAddressToShippingAddress}
              variant="go"
              text={model.updateBillingAddressText}
              isModalOpeningOnError={true}
              onOpenModal={model.openEditAddressModal}
            />
          ))}
      </div>
    </div>
  )
}
